import * as defaultImport from "@splunk/splunk-utils/config";
export * from "@splunk/splunk-utils/config";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
